<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">

        <div class="modal-header">
          <span class="modal-header-txt">{{$t('create_a_session')}}</span>
        </div>

        <div class="session-form">
          <span class="form-label">{{$t('user_title')}}</span>
          <SelectBox
              :full-width="true"
              class="select-box"
              :options="userOptions"
              :selected-value="selectedUserId"
              :on-select="onSelectUser"
              :search-enabled="true"
              :placeholder="this.$t('select_user_for_session')"
          />

          <div class="double-form">
            <div class="w-100">
              <span class="form-label">{{$t('date')}}</span>
              <input type="date" class="form-input" :placeholder="$t('date')" @input="(event) => {
                handleDate(event.target.value);
              }" v-model="selectedDate" />
            </div>

            <div class="w-100">
              <span class="form-label">{{$t('time')}}</span>
              <SelectBox
                  :full-width="true"
                  class="select-box"
                  :options="timeOptions"
                  :loading="timesLoading"
                  :selected-value="selectedTimeSlotId"
                  :on-select="onSelectTime"
                  :placeholder="this.$t('select_time_for_session')" />
            </div>
          </div>

          <span class="form-label">{{$t('notes_optional')}}</span>
          <input class="form-input mb-3" :placeholder="$t('specific_note_add')" v-model="note" />

          <span class="form-label">{{$t('meeting_link')}}</span>
          <input class="form-input" :placeholder="$t('meeting_link')" v-model="meetUrl" />
        </div>


        <div class="btn-div2">
          <div></div>
          <div class="action-button" @click="handleSave">
            <span v-if="!isLoading">{{$t('save_button')}}</span>
            <VueSpinnerIos v-if="isLoading" size="20" height="100%" color="#fff" />
          </div>
        </div>
        <div @click="this.onHide" class="close-btn">
          <img class="cross" src="../../assets/images/cross.svg" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import expertService from "@/service/expertService";

import {
  VueSpinnerIos
} from 'vue3-spinners'
import SelectBox from "@/components/SelectBox.vue";
import commonService from "@/service/commonService";
import {handleErrorResponse} from "@/utils/utils";

export default {
  components: {
    SelectBox,
    VueSpinnerIos
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    expertId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      isLoading: false,
      userOptions: [],
      selectedUserId: null,
      selectedDate: null,
      timesLoading: false,
      timeOptions: [],
      selectedTimeSlotId: null,
      note: "",
      meetUrl: ""
    };
  },
  mounted() {
    commonService.getUsers().then((res) => {
      this.userOptions = res.data.data.users.map((item) => {
        return {
          value: item.id,
          text: item.name
        };
      });
    });
  },
  methods: {
    async handleDate(date) {
      this.timesLoading = true;

      const formattedDate = this.$moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');

      await expertService.getReservationAvailability(this.expertId, formattedDate).then((res) => {
        if (res.data.data.length > 0) {
          this.timeOptions = res.data.data.map((item) => {
            return {
              value: item.expertSlotTimeId,
              text: item.time
            };
          });
        }
        this.timesLoading = false;
      });

    },
    onSelectUser(value) {
      this.selectedUserId = value;
    },
    onSelectTime(value) {
      this.selectedTimeSlotId = value;
    },
    handleSave() {
      if (!this.selectedUserId || !this.selectedDate || !this.selectedTimeSlotId || this.isLoading) {
        return;
      }

      this.isLoading = true;

      const data = {
        expertId: this.expertId,
        userId: this.selectedUserId,
        expertSlotTimeId: this.selectedTimeSlotId,
        date: this.formatDate(this.selectedDate),
        note: this.note,
        meetUrl: this.meetUrl
      };

      expertService.addReservation(data).then((res) => {
        this.$snackbar.add({
          text: this.$t('session_created_success'),
          type: "success",
        });
        this.isLoading = false;
        this.onHide();
      }).catch((err) => {
        handleErrorResponse(err, this.$snackbar)
        this.isLoading = false;
      });
    },
    formatDate(date) {
      const dateObject = new Date(date);

      const day = String(dateObject.getDate()).padStart(2, '0');
      const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Month is zero-based
      const year = dateObject.getFullYear();

      return `${day}.${month}.${year}`;
    }
  },

};
</script>

<style scoped>

.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}
.cross{
  padding: 8px;
}
.modal-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}
.modal-header-txt{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}

.action-button{
  display: flex;
  border-radius: 24px;
  background: #040C2D;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 48px;
  cursor: pointer;
}

.action-button span {
  font-family: euclid_medium, sans-serif;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.btn-div2{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  bottom: 30px;
  left: 24px;
  right: 24px;
}


.double-form{
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 15px;
}

.session-form {
  height: 100%;
}

.select-box {
  margin-bottom: 10px;
}
</style>
